export const defaultValues = {
  expenseReportNumber: '',
  employeePersonnelNumber: '',
  costDateFrom: '',
  costDateTo: '',
  country: '',
  city: '',
  categoryName: '',
};
